import { Item } from "@/dto/item";
import { Merchant } from "@/dto/merchant";
import { redirect } from "next/navigation";
import {
  getFromSessionStorage,
  removeFromSessionStorage,
} from "./sessionStorageUtils";
import { GiftCardInfo } from "@/dto/giftCardInfo";
import { SessionStorageKey } from "./storageKeys";

export const giftCardCategory = {
  id: "GIFTCARD",
  name: "Gift Card",
  numberOfItems: 1,
  sortOrder: 0,
  items: ["GIFTCARD_ITEM"],
};

export const giftCardItem: Item = {
  id: "GIFTCARD_ITEM",
  name: "Digital Gift Card",
  options: [],
  price: 0,
  modifierGroupIds: [],
  categoryIds: [giftCardCategory.id],
  taxIds: [],
  images: [],
  available: true,
  serviceItem: [],
  modifiedTime: Date.now(),
  isAgeRestricted: false,
};

export const giftCardRoute: string = "/giftcard";

/**
 * @deprecated This method is replaced by Merchant.isStandaloneGiftCardWebsite
 */
export const isStandaloneGiftCardWebsite = (
  merchant?: Merchant | null
): boolean => {
  if (!merchant) {
    return false;
  }
  return merchant?.isSellingGiftCards && merchant?.services?.length === 0;
};

export const redirectStandaloneGiftCard = (merchant: Merchant) => {
  if (merchant.isStandaloneGiftCardWebsite) {
    redirect(giftCardRoute);
  }
};

export const removeGiftCardInfo = () => {
  const giftCard = getFromSessionStorage<GiftCardInfo | null>(
    SessionStorageKey.GIFT_CARD_INFO,
    null
  );
  if (giftCard) {
    removeFromSessionStorage(SessionStorageKey.GIFT_CARD_INFO);
  }
};

export const GIFT_AMOUNT_MIN = 5;
export const GIFT_AMOUNT_MAX = 500;
export const GIFT_AMOUNT_DEFAULT = 10;

export const getDefaultInfoMessage = (t: any, currencySymbol: string) => {
  return t("defaultInfoMessage", {
    currencySymbol,
    min: GIFT_AMOUNT_MIN,
    max: GIFT_AMOUNT_MAX,
  });
};
